import { CycleUtils } from '@wix/package-picker-shared';
import {
  useIsStudioNewUi,
  useSelectedCycle,
} from '@wix/package-picker-shared-studio';
import { CycleSelector as PlatformCycleSelector } from '@wix/premium-purchase-platform/@components';
import { PurchaseOffering } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import { CYCLE_SELECTOR_DATA_HOOKS } from './CycleSelector.datahooks';
import { CycleSelectorHeader } from './CycleSelectorHeader';
import { CycleSelectorItem } from './CycleSelectorItem';

export const CycleSelector = () => {
  const selectedProductId =
    StudioPackagePickerModule.SDK.PackagePickerStore.useSelectedProductId();
  const selectedCycle = useSelectedCycle();
  const isStudioNewUi = useIsStudioNewUi();

  const handleSelectCycle = (cycle: PurchaseOffering.PurchaseCycle) => {
    StudioPackagePickerModule.SDK.PackagePickerStore.setSelectedCycleId(
      CycleUtils.convertCycleToCycleId(cycle),
    );
    StudioPackagePickerModule.internals.bi.onSelectCycle?.({
      cycle,
      productId: selectedProductId,
    });
  };

  if (!selectedProductId) {
    return null;
  }

  return (
    <PlatformCycleSelector.Root
      productId={selectedProductId}
      gap={isStudioNewUi ? '12px' : '-1px'}
      width={isStudioNewUi ? '100%' : '662px'}
      dataHook={CYCLE_SELECTOR_DATA_HOOKS.component}
    >
      {(pricingDetails) => {
        return [
          !isStudioNewUi && (
            <CycleSelectorHeader productId={selectedProductId} />
          ),
          pricingDetails.map((pricingDetail, idx) => {
            const isSelected = CycleUtils.isCycleEqual(
              selectedCycle,
              pricingDetail.cycle,
            );
            return (
              <CycleSelectorItem
                key={idx}
                idx={idx}
                isSelected={isSelected}
                pricingDetail={pricingDetail}
                productId={selectedProductId}
                selectCycle={handleSelectCycle}
              />
            );
          }),
        ];
      }}
    </PlatformCycleSelector.Root>
  );
};
